'use client';

import { useUserWallets } from '@dynamic-labs/sdk-react-core';
import { useQueryClient } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { tw } from '@repo/ui';
import { getImageUrl } from '@repo/utils';

import { registerSuccessAtom } from '@claim/atoms';
import { useClaim } from '@claim/hooks/use-claim';
import { useIsClaimEnded } from '@claim/hooks/use-claim-ended';

import { useIsClaimActive } from '../../hooks/use-claim-active';
import { UserDropdown } from './user-dropdown';

export const Navigation: React.FC = () => {
  const { setIsClaiming, setSuccess } = useClaim();
  const setRegisterSuccess = useSetAtom(registerSuccessAtom);
  const pathname = usePathname();
  const queryClient = useQueryClient();
  const userWallets = useUserWallets();

  const isClaimActive = useIsClaimActive();
  const isClaimEnded = useIsClaimEnded();

  const isActive = (path: string) => {
    return pathname === path ? 'font-bold' : 'font-normal';
  };

  const handleReset = () => {
    setRegisterSuccess(false);
    setSuccess(false);
    setIsClaiming(false);
    const queryKey = [
      'assets for user',
      userWallets.map((wallet) => wallet.address),
    ];
    queryClient.invalidateQueries({
      queryKey,
      refetchType: 'active',
    });
  };

  return (
    <div className='flex w-full items-center justify-between px-4 pt-6'>
      <div className='flex items-center gap-5'>
        <Image
          alt='$DOOD logo'
          src={getImageUrl('/claim/images/header-dood.svg')}
          height={25}
          width={25}
          onClick={() => handleReset()}
          className='hover:cursor-pointer'
        />
        <Link
          className={tw(isActive('/'), 'tracking-wide text-white')}
          onClick={() => handleReset()}
          href={'/'}
        >
          {isClaimActive || isClaimEnded ? 'Claim' : 'Register'}
        </Link>

        <Link
          className={tw(isActive('/faq'), 'text-white')}
          href='/faq'
        >
          FAQ
        </Link>

        <a
          className={'text-white'}
          href='https://dreamnet.doodles.app'
          target='_blank'
          rel='noreferrer'
        >
          Whitepaper
        </a>
      </div>
      <UserDropdown />
    </div>
  );
};
